/* eslint-disable no-unused-vars */
import React, { useMemo } from 'react';

import MoreInformation from '@components/more-information';
import Icon from '@components/icon-component';

import style from './style.module.scss';
import { decodeToken } from '@utilities/authentication';

import PermissionRestrict from 'hoc/permission-restrict';
import { PERMISSIONS } from 'permissions/constants';

const EquipmentDetailsMoreInfo = ({
  moreInfoDataPointsMap,
  setEditEquipment,
  moreInfoOfVessel,
  moreInfoOfPSVs,
  otherCategories,
  editEquipmentBtnEvent
}) => {
  const permissions = decodeToken()?.permissions || {};
  const openInDesktop = ({ link }) => {
    window.open(link, '_blank');
  };

  const canEdit = useMemo(() => {
    if (permissions) return permissions[PERMISSIONS.MOBILE_CREATEEDIT_EQUIPMENT] ? true : false;
    else return false;
  }, [permissions, PERMISSIONS]);

  return (
    <>
      <MoreInformation
        info={Object?.keys(moreInfoDataPointsMap)?.map((a) => {
          return {
            title: moreInfoDataPointsMap[a]?.value || null,
            heading: moreInfoDataPointsMap[a]?.title || null
          };
        })}
        canEdit={canEdit}
        editBtnEvent={editEquipmentBtnEvent}
      />

      {moreInfoOfVessel?.length > 0 || moreInfoOfPSVs?.length > 0 ? (
        <div className={style.divider}>
          <p>Attached</p>
        </div>
      ) : (
        <></>
      )}

      {moreInfoOfVessel?.length > 0 ? (
        <div className={style.moreInfoBody}>
          {moreInfoOfVessel?.map((moreInfoOfPSV, index) => {
            return (
              <div key={index}>
                <div className={style.content}>
                  <span className={style.title}>{moreInfoOfPSV.title}</span>
                  <span className={style.name}>
                    <div>{moreInfoOfPSV.name}</div>
                    <Icon
                      name={'feather-link'}
                      height={14}
                      width={14}
                      onClick={() => {
                        openInDesktop({ link: `/equipment-details/${moreInfoOfPSV.id}` });
                      }}
                    />
                  </span>
                  <span className={style.serial}> Serial #: {moreInfoOfPSV.serial}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <></>
      )}

      {moreInfoOfPSVs?.length > 0 ? (
        <div className={style.moreInfoBody}>
          {moreInfoOfPSVs?.map((moreInfoOfPSV, index) => {
            return (
              <div key={index}>
                <div className={style.content}>
                  <span className={style.title}>{moreInfoOfPSV.title}</span>
                  <span className={style.name}>
                    <div>{moreInfoOfPSV.name}</div>
                    <Icon
                      name={'feather-link'}
                      height={14}
                      width={14}
                      onClick={() => {
                        openInDesktop({
                          link: `/equipment-details/${moreInfoOfPSV.id}`
                        });
                      }}
                    />
                  </span>
                  <span className={style.serial}> Serial #: {moreInfoOfPSV.serial}</span>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <></>
      )}

      {otherCategories?.length > 0 ? (
        <>
          <div className={style.divider}>
            <p>More info</p>
          </div>
          <div className={style.moreInfoBody}>
            {otherCategories?.map((x, index) => {
              return (
                <div key={index}>
                  <div className={style.content}>
                    <div className={style.customTitle}>{x.title}</div>
                    <div className={style.customValue}>{x.value}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default EquipmentDetailsMoreInfo;
